const ASSET_TYPES = Object.freeze({
  image: 'image',
  video: 'video',
  playlist: 'playlist',
  sign: 'sign',
});

export default ASSET_TYPES;
